import React, { Suspense, lazy, memo } from 'react';
import { SkeletonChart } from './feedback/Skeleton';
import {
  KommunTrendData,
  DynamicTrendData,
  DynamicDistributionData,
  DriverData,
  InsightData,
  SchoolDistributionData,
  CorrelationYearSummary
} from '../hooks/useKommunData';

// Lazy load the heavy analysis components
const AnalysisTabs = lazy(() => import('./AnalysisTabsWithSwipe'));

interface LazyAnalysisPanelProps {
  activeKpi: string | null;
  kpiName: string;
  latestYear: number;
  kommunId: string | null;
  skolaId: string | null;
  loading: boolean;
  trendData: KommunTrendData[];
  dynamicTrendData: DynamicTrendData[];
  distributionData: SchoolDistributionData[];
  dynamicDistributionData: DynamicDistributionData[];
  driverData: DriverData[];
  insightData: InsightData | null;
  correlationData: Record<string, CorrelationYearSummary[]>;
  riketData: Record<string, { year: number; r: number }[]>;
  className?: string;
}

const LazyAnalysisPanel: React.FC<LazyAnalysisPanelProps> = ({
  activeKpi,
  kpiName,
  latestYear,
  kommunId,
  skolaId,
  loading,
  trendData,
  dynamicTrendData,
  distributionData,
  dynamicDistributionData,
  driverData,
  insightData,
  correlationData,
  riketData,
  className
}) => (
  <div className={className}>
    <Suspense fallback={<SkeletonChart />}>
      <AnalysisTabs
        activeKpi={activeKpi || ''}
        kpiName={kpiName}
        latestYear={latestYear}
        trendData={trendData}
        dynamicTrendData={dynamicTrendData}
        distributionData={distributionData}
        dynamicDistributionData={dynamicDistributionData}
        driverData={driverData}
        insightData={insightData}
        correlationData={correlationData}
        riketData={riketData}
        kommunId={kommunId || undefined}
        skolaId={skolaId}
        loading={loading}
      />
    </Suspense>
  </div>
);

export default memo(LazyAnalysisPanel);
